import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogin, authLogout, setupOwner, updateProfile as apiUpdateProfile } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    // If returning from Google OAuth, skip the /me check — AuthCallback exchanges
    // the session_id and establishes the session cookie first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const u = await authMe();
      setUser(u);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    await authLogin(email, password);
    await load();
  };
  const setup = async (name, email, password) => {
    await setupOwner({ name, email, password });
    await load();
  };
  const logout = async () => {
    try { await authLogout(); } catch {}
    setUser(null);
    window.location.assign("/");
  };
  const updateProfile = async (body) => {
    const u = await apiUpdateProfile(body);
    setUser(u);
    return u;
  };

  const isAdmin = user?.role === "super_admin" || user?.role === "agency_admin";
  const seesAll = user?.role === "super_admin" || user?.role === "agency_admin" || user?.role === "agency_staff";
  const can = (perm) => isAdmin || !!user?.permissions?.[perm];

  return (
    <AuthContext.Provider value={{ user, loading, login, setup, logout, updateProfile, refreshUser: load, isAdmin, seesAll, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
